module.exports = __webpack_public_path__ + "static/img/01042615a90e34c8e05bb700f2408ecc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s_icon2.png
// module id = kKHo
// module chunks = 1